module.exports = __webpack_public_path__ + "img/blue-reminder-icon.46dd48a4.svg";